import { PageEvent } from '@spartacus/storefront'

export class SearchPageZeroResultsEvent extends PageEvent {

    static readonly type = 'SearchPageZeroResultsEvent'

    searchTerm?: string
}
